(function () {
  var bar = document.querySelector('[data-mn-sticky]');
  if (!bar) return;

  var sectionId = bar.getAttribute('data-main-section');
  var mainButton = document.getElementById('ProductSubmitButton-' + sectionId);
  var addButton = bar.querySelector('[data-mn-add]');
  var priceEl = bar.querySelector('[data-mn-price]');
  var mainRoot = document.getElementById('MainProduct-' + sectionId);
  if (!mainButton || !addButton || !mainRoot) return;

  var defaultLabel = addButton.textContent.trim();
  var inView = true;

  function isDisabled() {
    return mainButton.hasAttribute('disabled') || mainButton.getAttribute('aria-disabled') === 'true';
  }

  function sync() {
    var price = document.querySelector('#price-' + sectionId + ' .price-item--last');
    if (price && priceEl) {
      priceEl.textContent = price.textContent.trim();
    }

    var disabled = isDisabled();
    addButton.disabled = disabled;
    var label = mainButton.querySelector('span');
    addButton.textContent = disabled && label && label.textContent.trim() ? label.textContent.trim() : defaultLabel;
  }

  function render() {
    var show = !inView;
    bar.hidden = !show;
    document.documentElement.classList.toggle('mn-sticky-on', show);
  }

  addButton.addEventListener('click', function () {
    if (!isDisabled()) {
      mainButton.click();
    }
  });

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      inView = entries[0].isIntersecting;
      render();
    }).observe(mainButton);
  }

  new MutationObserver(sync).observe(mainRoot, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['disabled', 'aria-disabled'],
  });

  sync();
})();
